import React, { useState } from "react";
import { fetchOneMapData } from "../../../services/api/onemapApi";

const OneMapField = (props) => {
  const {
    label,
    type,
    name,
    id,
    placeholder,
    error,
    helpertext,
    handleOnChange,
    value,
  } = props;
  const [valueData, setValueData] = useState(!!value ? value : "");

  const onChange = async (e) => {
    setValueData(e.target.value);
    let apiResponse;
    if (e.target.value?.length === 6) {
      apiResponse = await fetchOneMapData(e.target.value);
    }
    handleOnChange(apiResponse?.results[0]);
  };

  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
        </label>
      )}
      <input
        type={type}
        className="form-control"
        id={id}
        name={name}
        value={valueData}
        onChange={onChange}
        placeholder={placeholder}
        maxLength="6"
      />
      <p className="form-error-message">{error && helpertext}</p>
    </div>
  );
};

export default OneMapField;
